<!-- 顶部LOGO、搜索栏、导航栏组件 -->
<template>
  <Modal
      v-model="open"
      @on-cancel="$emit('close')"
      :title="language.modalTitle"
      width="1200px"
      footer-hide>
      <div class="modal">
        <form2 type="modal" :key2="key2" :name="name" @close="$emit('close')"></form2>
      </div>
  </Modal>
</template>

<script>
export default {
  name: 'formModal',
  inject: ['reload'],
  props: ["name", "key2", "open"],
  data() {
    return {
      language: {},
    };
  },
  methods: {
    
  },
  created() {
    this.language = this.$language[this.$store.state.pageType].form;
  }
};
</script>

<style scoped lang='scss'>
  .modal{
    & >>> .zixun{
      padding: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/formModal.vue